<template>
  <div class="ion-page">
    <ion-header translucent>
      <ion-toolbar>
        <ion-title>Uitnodigingen</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content fullscreen>
      
    </ion-content>
  </div>
</template>
<script>
  export default {
    name: 'caregiverInvites',
    components: {
    },
    data() {
      return {
        info: null,
        i: 0,
      };
    },
    methods: {}
  };
</script>
